import { render, staticRenderFns } from "./emp-create-admin.vue?vue&type=template&id=bc19f8c4&scoped=true&"
import script from "./emp-create-admin.vue?vue&type=script&lang=js&"
export * from "./emp-create-admin.vue?vue&type=script&lang=js&"
import style0 from "./emp-create-admin.vue?vue&type=style&index=0&id=bc19f8c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc19f8c4",
  null
  
)

export default component.exports